
/*
 * Wizard steps action types
 */

export const CREATE_PRODUCT = 'CREATE_PRODUCT';

export const createProduct = (id, packageId, packageCode, productCode, contractTermId, name, amount, users, language, wizardType) => ({
    type: CREATE_PRODUCT,
    id,
    packageId,
    packageCode,
    productCode,
    contractTermId,
    name,
    amount,
    users,
    language,
    wizardType
});